export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_ERROR = "FETCH_USERS_ERROR";

export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";

export const SET_ADMIN_REDUCER = "SET_ADMIN_REDUCER";
export const TESTING_SUCCESS = "TESTING_SUCCESS";
export const TESTING_ERROR = "TESTING_ERROR";
export const DOWNLOAD_TEST_RES_SUCCESS = "DOWNLOAD_TEST_RES_SUCCESS";

export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const CREATE_USER_ERROR = "CREATE_USER_ERROR";
